<template>
  <div class="card-ad-results" :class="tileViewMode">
    <div
      v-for="result in results"
      :key="result.id"
      class="card-ad-results__result"
      :class="`card-ad-results__result--${tileViewMode}-view`"
    >
      <CardAd v-bind="{ ...result }"></CardAd>
    </div>
  </div>
</template>

<script>
import CardAd from '@components/CardAd/CardAd.vue'

export default {
  components: {
    CardAd,
  },
  props: {
    tileViewMode: { default: 'default', type: String },
    results: {
      default: () => {
        return []
      },
      type: Array,
    },
  },
}
</script>

<style lang="scss">
@import 'CardAdResults.scss';
</style>
